import { render, staticRenderFns } from "./publish_modal.vue?vue&type=template&id=56f7306d&lang=pug"
import script from "./publish_modal.vue?vue&type=script&lang=js"
export * from "./publish_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports